export default "__VITE_ASSET__98cf7b60__"